import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { LoadingService } from "../../../../services/loading.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { AventuraService } from "../../../../services/api/aventura.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogTrekkingComponent } from "../trekking/dialog-trekking/dialog-trekking.component";
import { hasServiceOrder } from 'src/entities/file/lib/service-table.utils';
import { applyCreatedOrdersToServices } from 'src/entities/order';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import { MatSort } from '@angular/material/sort';
import { Router } from "@angular/router";
import { CocinaService } from "../../../../services/api/cocina.service";
import { CognitoService } from 'src/app/services/cognito.service';

@Component({
  selector: 'app-all',
  templateUrl: './all.component.html',
  styleUrls: ['./all.component.css'],
  // animations: [
  //   trigger('detailExpand', [
  //     state('collapsed', style({ height: '0px', minHeight: '0' })),
  //     state('expanded', style({ height: '*' })),
  //     transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  //   ]),
  // ],
})
export class AllComponent implements OnInit {

  @Input() dataModel: any

  loader: boolean = false;
  model: any = null
  listFileProduct: any = [];
  files: any = [];
  modelExpand: any;
  estadoBtnMasivo: any;
  dataSource: any;
  messageButtonOS: any = null
  loadingOS: boolean = false
  resultOS: any

  selectedFile: string | null = null;
  selectedSubCategoria: string | null = null;
  selectedCategoriaProducto: string | null = null;
  selectedSubCategoriaProducto: string | null = null;
  selectedTipoServicio: string | null = null;

  arraySubCategoria: any = ['COCINERO', 'ASISTENTECOCINA', 'BANERO', 'CARPERO', 'PORTEADOR', 'PORTEADOREXTRA',
    'JEFEPORTEADOR', 'ARRIEROCARGA', 'ARRIEROCABALLO', 'JEFEARRIERO', 'ACEMILA', 'PARAMEDICO',
    'DOCTOR', 'CHEF', 'MASAJISTA', 'TRASLADISTA', 'TOURCONDUCTOR', 'CHOFER', 'ASISTENTEDEPICNIC',
    'PORTEADORMENAJERO', 'GUIAMONTAÑA', 'ASISTENTEGUIAMONTAÑA', 'ELITE', 'PRO', 'EXPERT', 'ASISTENTE', 'BIKING'];
  arrayCategoriaProducto: any = ['BIKINGADVENTURES', 'HIKING&TREKKING'];
  arraySubCategoriaProducto: any = ['TREKKING', 'HIKING', 'SELFGUIDEDHIKES', 'TRAILRUN', 'LODGETOLODGETREKS', 'ROADBIKES', 'MOUNTAINBIKES', 'SELFGUIDEDBIKETOURS', 'EBIKES'];
  arrayTipoServicio: any = ['GUIA', 'PERSONALDECAMPO'];

  services: any[] = []
  fileArray: any[] = []

  usuario: string = '';

  // displayedColumns: string[] = ['fileNumber', 'categoriaProducto', 'subCategoriaProducto', 'ruta', 'edit'];
  // displayedColumns2: string[] = ['fileNumber', 'categoriaProducto', 'subCategoriaProducto', 'ruta', 'createdAt', 'updatedAt'];
  // columnsToDisplayWithExpand = [...this.displayedColumns2, 'expand'];


  displayedColumnsServicios: string[] = ['Check', 'fileNumber', 'categoriaProducto', 'subCategoriaProducto', 'ruta', 'nombre', 'categoriaServicio', 'proveedor', 'orderNumber', 'reservationStatus', 'cambiarProvider'];


  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.dataSource.sort = value;
  }

  constructor(private router: Router, private changeDetectorRefs: ChangeDetectorRef, public dialog: MatDialog, public loadingService: LoadingService, private aventuraService: AventuraService, private fileService: FileService, private functions: FunctionsService, private userService: CognitoService) { }

  ngOnInit(): void {
/*     this.userService.getAuthenticatedUser().then((data) => {
      this.usuario = `${data.attributes.middle_name} ${data.attributes.family_name}`;

      console.log('user', this.usuario);
    }) */
    this.usuario=`${localStorage.getItem('nombre')} ${localStorage.getItem('apellido')}`
    this.dataSource = new MatTableDataSource();
    this.loader = true
    this.arraySubCategoria.sort()
    // this.functions.disparadorCambiosProvider.subscribe(data => {


    // })
    // this.functions.disparadorCambios.subscribe((t: string) => {

    //   if (t) {
    //     this.ngOnInit()

    //   }

    // })

    let array: any[] = []

    this.dataModel.map((el: any) => {
      el.services.map((service: any) => {
        console.log(service.fileNumber)
        array.push(service.fileNumber)
        this.services.push(service)
      })
    })

    this.fileArray = [...new Set(array)];

    this.dataSource.data = this.services

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.changeDetectorRefs.detectChanges();
    this.loader = false
  }


  // openDialogEdit(id: any, productId: any, idItinerary: any): void {
  //
  //   let i = 0;
  //
  //
  //   console.log(id)
  //   this.listFileProduct.map((el: { fileId: any; fileProductId: any }, index: any) => {
  //     if (el.fileId == id && el.fileProductId == productId) {
  //       i = index;
  //     }
  //   })
  //   console.log(i)
  //
  //   let dialogConfig = new MatDialogConfig();
  //   dialogConfig.autoFocus = false, dialogConfig.maxHeight = '90vh'
  //
  //   console.log(this.listFileProduct[i])
  //
  //   dialogConfig.data = {
  //     file: this.listFileProduct[i],
  //     estado: 2,
  //     idItinerary: idItinerary
  //   };
  //
  //
  //   dialogConfig.width = "50%";
  //
  //   let dialogRef = this.dialog.open(DialogTrekkingComponent, dialogConfig);
  //
  //   dialogRef.afterClosed().subscribe(result => {
  //     // console.log("closed");
  //     // console.log(result.result.map((el:any)=>el.result))
  //
  //
  //     if (result?.result) {
  //       console.log(result?.result)
  //       this.ngOnInit();
  //     }
  //
  //   });
  // }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    console.log(filterValue)
    console.log(this.dataModel)

    this.dataSource.data.forEach((element: { [x: string]: string; }) => {
      for (const key in element) {
        if (!element[key] || element[key] === null) {
          element[key] = '';
        }
      }
    });

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async sendReservaOS(): Promise<any> {
    const serviceIds = [
      ...new Set(
        (this.dataSource.data ?? [])
          .filter((x: any) => x.checked === true && !hasServiceOrder(x))
          .map((s: any) => s.id)
          .filter(Boolean)
      )
    ] as string[]

    if (!serviceIds.length) {
      if (this.estadoBtnMasivo == 0) this.messageButtonOS = true
      return
    }

    const operationDates = (this.dataSource.data ?? [])
      .filter((x: any) => x.checked === true && !hasServiceOrder(x))
      .map((s: any) => s.startDateService ?? s.dateToShow ?? null)

    const dialogRef = this.functions.openCreateOrderDialog({
      serviceIds,
      operationDates,
      contextLabel: 'Programación'
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) return

      if (result.shouldRefresh) {
        this.estadoBtnMasivo = 0
        this.functions.disparadorCambios.emit('reload-after-create-order')
        return
      }

      if (result.success) {
        applyCreatedOrdersToServices(
          this.services,
          result.result?.createdOrders,
          'id',
          result.submittedInput
        )
        this.estadoBtnMasivo = 0
        this.dataSource.data = [...this.services]
        this.changeDetectorRefs.detectChanges()
      }
    })
  }



  updateCheck(row: any) {
    row.checked = !row.checked;
    console.log('check model', this.model);
    if (row.checked == true) {
      this.estadoBtnMasivo = Number(this.estadoBtnMasivo) + Number(1);
    } else {
      this.estadoBtnMasivo = Number(this.estadoBtnMasivo) - Number(1);
    }
  }



  isAllSelected(array: any) {
    //console.log('is all cjecked')
    let lstHoteles: any[];
    lstHoteles = array.filter((x: any) => x.checked == true);
    const numSelected = lstHoteles.length;
    const numRows = array.length;
    return numSelected === numRows;
  }


  toggleAllRows(array: any) {
    if (this.isAllSelected(array)) {
      array.map((fila: any) => {
        fila.checked = false;
      });
      console.log('verifica checked', array.filter((x: any) => x.checked == true));
      this.estadoBtnMasivo = 0;
      return;
    } else {
      array.map((fila: any) => {
        fila.checked = !fila.checked;
      });
      console.log('verifica checked', array.filter((x: any) => x.checked == true));
      this.estadoBtnMasivo = array.length;
      return;
    }
  }

  openDialogProvider(tipo: String, nombreServicio: String, idItinerary: String, idRegistro: string, nombreProveedor: string, categoriaServicio: String, locacion: String) {
    // console.log(tipo, nombreServicio, idItinerary, idRegistro)
    this.functions.openDialogProvider(tipo, nombreServicio, idItinerary, idRegistro, nombreProveedor, 'All', categoriaServicio, locacion)
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log('ngOnChanges was called!');
    console.log(changes['dataModel'].currentValue);


    changes['dataModel'].currentValue.map((fila: any) => {
      fila.checked = false;
    });


    this.dataSource = new MatTableDataSource(changes['dataModel'].currentValue);

    console.log(this.dataSource.data)
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.estadoBtnMasivo = 0
    this.changeDetectorRefs.detectChanges();
    console.log(this.loader)
  }

  applyFilterSelect() {
    let dataNew: any = this.services

    console.log(dataNew)

    if (this.selectedFile) {
      dataNew = dataNew?.filter((item: any) => item.fileNumber === this.selectedFile)
    }
    if (this.selectedSubCategoria) {
      dataNew = dataNew?.filter((item: any) => item.objServicio.categoriaServicio === this.selectedSubCategoria)
      // dataNew= this.model.map((element:any) => {
      //   return {...element, services: element.services.filter((service:any) => service.categoriaServicio === this.selectedSubCategoria)}
      // })
    }
    if (this.selectedCategoriaProducto) {
      dataNew = dataNew?.filter((item: any) => item.objProducto.categoriaProducto === this.selectedCategoriaProducto)
    }

    if (this.selectedSubCategoriaProducto) {
      dataNew = dataNew?.filter((item: any) => item.objProducto.subCategoriaProducto === this.selectedSubCategoriaProducto)
    }

    if (this.selectedTipoServicio) {
      dataNew = dataNew?.filter((item: any) => item.tipoServicio === this.selectedTipoServicio)
    }

    this.dataSource.data = Array.isArray(dataNew) ? [...dataNew] : []

  }


}
